export default __webpack_public_path__ + "static/media/smile_transparent.0751be3c.svg";